import * as React from 'react'

import { Flex, Text } from '@chakra-ui/react'

import { ApiKeyEndpointMetadata } from '~/gen/proto/bff/v1/model_pb'

import { MethodBadge } from './MethodBadge'

export function matchesEndpointQuery(
  endpoint: ApiKeyEndpointMetadata,
  query: string,
): boolean {
  const q = query.trim().toLowerCase()
  if (q === '') {
    return false
  }
  return (
    `${endpoint.method} ${endpoint.path}`.toLowerCase().includes(q) ||
    endpoint.description.toLowerCase().includes(q)
  )
}

type Props = {
  endpoints: ApiKeyEndpointMetadata[]
  highlightQuery?: string
}

export const EndpointList: React.FC<Props> = ({
  endpoints,
  highlightQuery,
}) => {
  const query = highlightQuery?.trim() ?? ''

  return (
    <Flex flexDirection="column" gap="1">
      {endpoints.map((endpoint) => {
        const isMatch = query !== '' && matchesEndpointQuery(endpoint, query)
        return (
          <Flex
            key={`${endpoint.method} ${endpoint.path}`}
            alignItems="center"
            gap="3"
            borderRadius="radiiBase"
            backgroundColor={isMatch ? 'Surface.secondary' : undefined}
            paddingX="2"
            paddingY="2"
          >
            <MethodBadge method={endpoint.method} />
            <Text textStyle="textMd" fontFamily="mono">
              {endpoint.path}
            </Text>
            {endpoint.description !== '' && (
              <Text textStyle="textSm" color="Text.lowEmphasis">
                {endpoint.description}
              </Text>
            )}
          </Flex>
        )
      })}
    </Flex>
  )
}
